import api from "@/api.js";


export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    selectedAction: null
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedAction(state, payload) {
      state.selectedAction = payload;
    }
  },
  actions: {
    async loadAllBySolutionID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/actions/bySolutionID", {
        params: { id: id }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadActionByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/actions/byID", {
        params: { id: id }
      });
      commit("setSelectedAction", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/actions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySolutionID", payload.solutions_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`solutions/actions`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllBySolutionID", payload.solutions_id);
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list
    },
    selectedAction(state) {
      return state.selectedAction
    }
  }
}
